module.exports = __webpack_public_path__ + "img/tu_4.2e12fb47.png";